function copyToClipboard(element) {
  var $temp = $("<input>");
  var oldValue = $(element).html();

  $("body").append($temp);
  $temp.val($(element).html()).select();
  document.execCommand("copy");
  $(element).html("COPIADO");
  setTimeout(function(){ $(element).html(oldValue); }, 300);
  $temp.remove();
}

$('cupom').click(function(){
  copyToClipboard(this);
});

(function() {
  const params = new URLSearchParams(window.location.search);
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  const attributes = {};

  utmParams.forEach(param => {
    const value = params.get(param);
    if (value) {
      attributes[`${param}`] = value;
    }
  });

  if (Object.keys(attributes).length > 0) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ attributes })
    });
  }
})();

if (window.location.pathname === '/products/sache-sabonete-intimo-hidratante-feminino-dermosex-4-ml' || window.location.pathname === '/products/brinde-sache-creme-corporal-super-hidratante-dermosex-4g') {
  window.location.replace('/');
}

// A SÓS | Layout do cabeçalho desktop
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 1025) return;

  const style = document.createElement('style');
  style.id = 'asos-header-desktop-layout';
  style.textContent = `
    @media screen and (min-width: 1025px) {
      /* Mantém as categorias em uma única linha sem alterar a estrutura nativa do sticky header */
      .section-header-navigation .header-nav-vertical-menu .list-menu--inline {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex-wrap: nowrap !important;
        white-space: nowrap !important;
      }

      .section-header-navigation .header-nav-vertical-menu .menu-lv-item.menu-lv-1 {
        flex: 0 0 auto !important;
      }

      /* No topo, a navegação vira a segunda linha e os controles pertencem visualmente à primeira linha */
      body.template-index:not(.asos-header-scrolled) .section-header-navigation,
      body:not(.template-index) .section-header-navigation:not(.scrolled-past-header) {
        position: relative !important;
        width: 100% !important;
      }

      body.template-index:not(.asos-header-scrolled) .section-header-navigation .header-navigation-wrapper,
      body.template-index:not(.asos-header-scrolled) .section-header-navigation .header-navigation,
      body.template-index:not(.asos-header-scrolled) .section-header-navigation .header-nav-vertical-menu,
      body.template-index:not(.asos-header-scrolled) .section-header-navigation .header-nav-vertical-menu > .container,
      body:not(.template-index) .section-header-navigation:not(.scrolled-past-header) .header-navigation-wrapper,
      body:not(.template-index) .section-header-navigation:not(.scrolled-past-header) .header-navigation,
      body:not(.template-index) .section-header-navigation:not(.scrolled-past-header) .header-nav-vertical-menu,
      body:not(.template-index) .section-header-navigation:not(.scrolled-past-header) .header-nav-vertical-menu > .container {
        position: static !important;
      }

      body.template-index:not(.asos-header-scrolled) .section-header-navigation .header-nav-vertical-menu > .container,
      body:not(.template-index) .section-header-navigation:not(.scrolled-past-header) .header-nav-vertical-menu > .container {
        display: block !important;
      }

      body.template-index:not(.asos-header-scrolled) .section-header-navigation .header-nav-vertical-menu .main-menu,
      body:not(.template-index) .section-header-navigation:not(.scrolled-past-header) .header-nav-vertical-menu .main-menu {
        width: 100% !important;
        min-width: 0 !important;
      }

      body.template-index:not(.asos-header-scrolled) .section-header-navigation .header-nav-vertical-menu .main-menu--wrapper,
      body.template-index:not(.asos-header-scrolled) .section-header-navigation .header-nav-vertical-menu .header__inline-menu,
      body.template-index:not(.asos-header-scrolled) .section-header-navigation .header-nav-vertical-menu .list-menu--inline,
      body:not(.template-index) .section-header-navigation:not(.scrolled-past-header) .header-nav-vertical-menu .main-menu--wrapper,
      body:not(.template-index) .section-header-navigation:not(.scrolled-past-header) .header-nav-vertical-menu .header__inline-menu,
      body:not(.template-index) .section-header-navigation:not(.scrolled-past-header) .header-nav-vertical-menu .list-menu--inline {
        width: 100% !important;
      }

      /* Posicionamento inspirado na lógica da Sallve: logo no centro e ações afastadas à direita */
      body.template-index:not(.asos-header-scrolled) .section-header-navigation .header-icons,
      body:not(.template-index) .section-header-navigation:not(.scrolled-past-header) .header-icons {
        position: absolute !important;
        top: -52px !important;
        right: clamp(72px, 8.5vw, 180px) !important;
        left: auto !important;
        transform: none !important;
        z-index: 50 !important;
        width: auto !important;
        max-width: none !important;
        margin: 0 !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        flex-wrap: nowrap !important;
        pointer-events: auto !important;
      }

      body.template-index:not(.asos-header-scrolled) .section-header-navigation .header-icons-bottom,
      body:not(.template-index) .section-header-navigation:not(.scrolled-past-header) .header-icons-bottom {
        display: flex !important;
        align-items: center !important;
        flex-wrap: nowrap !important;
        gap: 14px !important;
        padding: 0 !important;
      }
    }
  `;

  document.getElementById(style.id)?.remove();
  document.head.appendChild(style);

  document
    .querySelectorAll(
      '.section-header-navigation .header-nav-vertical-menu details-modal.header__search'
    )
    .forEach(function (modal) {
      const details = modal.querySelector('details.search_details');
      const summary = details && details.querySelector('summary.header__icon--search');

      if (!details || !summary) return;

      summary.addEventListener(
        'click',
        function () {
          requestAnimationFrame(function () {
            const isOpen = details.hasAttribute('open');
            document.body.classList.toggle('sticky-search-menu-open', isOpen);
            summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          });
        },
        true
      );

      details.addEventListener('toggle', function () {
        const isOpen = details.hasAttribute('open');
        document.body.classList.toggle('sticky-search-menu-open', isOpen);
        summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      const closeButton = details.querySelector('.search-modal__close-button');
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          document.body.classList.remove('sticky-search-menu-open');
          summary.setAttribute('aria-expanded', 'false');
        });
      }
    });
});
